import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
    REQUEST_MESSAGES_COUNTER,
    REQUEST_MESSAGES_RANGE,
    REQUEST_USERS_COUNTER,
    REQUEST_USERS_RANGE,
    REQUEST_CONNECTIONS_COUNTER,
    REQUEST_CONNECTIONS_RANGE
} from './constants'
import {
    setMessagesCounter,
    setMessagesRange,
    setUsersCounter,
    setUsersRange,
    setConnectionsCounter,
    setConnectionsRange
} from './actions'
import DashboardClient from '../../apiClient/DashboardClient'

const dashboardClient = new DashboardClient()

function* getMessagesCounter({ payload }) {
    try {
        const messagesCounter = yield call(dashboardClient.countMessages)
        yield put(setMessagesCounter({ messagesCounter }))
    } catch (e) {
        console.warn(e)
    }
}
function* getMessagesRange({ payload }) {
    try {
        let messagesRange
        if (payload.to && payload.from) {
            messagesRange = yield call(dashboardClient.messagesRange, { to: payload.to, from: payload.from })
        } else {
            messagesRange = yield call(dashboardClient.messagesRange)
        }
        yield put(setMessagesRange({ messagesRange }))
    } catch (e) {
        console.warn(e)
    }
}

function* getUsersCounter({ payload }) {
    try {
        const usersCounter = yield call(dashboardClient.countUsers)
        yield put(setUsersCounter({ usersCounter }))
    } catch (e) {
        console.warn(e)
    }
}
function* getUsersRange({ payload }) {
    try {
        let usersRange
        if (payload.to && payload.from) {
            usersRange = yield call(dashboardClient.usersRange, { to: payload.to, from: payload.from })
        } else {
            usersRange = yield call(dashboardClient.usersRange)
        }
        yield put(setUsersRange({ usersRange }))
    } catch (e) {
        console.warn(e)
    }
}

function* getConnectionsCounter({ payload }) {
    try {
        const connectionsCounter = yield call(dashboardClient.countConnections)
        yield put(setConnectionsCounter({ connectionsCounter }))
    } catch (e) {
        console.warn(e)
    }
}

function* getConnectionsRange({ payload }) {
    try {
        let connectionsRange
        if (payload.to && payload.from) {
            connectionsRange = yield call(dashboardClient.connectionsRange, { to: payload.to, from: payload.from })
        } else {
            connectionsRange = yield call(dashboardClient.connectionsRange)
        }
        yield put(setConnectionsRange({ connectionsRange }))
    } catch (e) {
        console.warn(e)
    }
}

export default function* appSagas() {
    yield all([
        takeEvery(REQUEST_MESSAGES_COUNTER, getMessagesCounter),
        takeEvery(REQUEST_MESSAGES_RANGE, getMessagesRange),

        takeEvery(REQUEST_USERS_COUNTER, getUsersCounter),
        takeEvery(REQUEST_USERS_RANGE, getUsersRange),

        takeEvery(REQUEST_CONNECTIONS_COUNTER, getConnectionsCounter),
        takeEvery(REQUEST_CONNECTIONS_RANGE, getConnectionsRange)
    ])
}
